import PropTypes from "prop-types";
import Button from "../Button";
import { ImageSourcesType } from "../Image/types";
import Image from "../Image";
import BackgroundVideo from "../BackgroundVideo";

export default function HeroVideo({
  title,
  description,
  handleButtonClick,
  source,
  heroLogo,
  buttonText,
  mode,
  fallbackImageSource,
}) {
  return (
    <>
      <div
        className="relative flex items-end h-3xl md:h-screen-xs lg:h-screen-sm p-md rounded-t-lg md:rounded-b-lg overflow-hidden transition-shadow shadow-darkSM hover:shadow-darkLG"
        data-testid="homepageHeroVideo"
      >
        <div className="cursor-pointer" role="button" tabIndex={0}>
          <BackgroundVideo
            source={source}
            fallbackImage={{ sources: fallbackImageSource, alt: title }}
            className="absolute w-full h-full object-cover top-0 right-0 left-0 bottom-0 bg-cover bg-center"
          />
        </div>
        <div
          className={`hidden md:flex absolute bottom-0 right-0 w-full pt-xl items-center justify-between bg-gradient-to-t ${
            mode === "light" ? "from-gray-200" : "from-gray-800"
          }  to-transparent`}
        >
          <div
            className={`w-3/4 p-lg ${
              mode === "light" ? "text-gray-900" : "text-white"
            }`}
          >
            <div className="flex flex-col items-start">
              <p
                className="gn-headline-sm mb-xs"
                style={{ textShadow: `3px 3px 3px rgba(0, 0, 0, 0.25)` }}
              >
                {title}
              </p>
              <p
                className="gn-text mb-sm"
                style={{ textShadow: `3px 3px 3px rgba(0, 0, 0, 0.5)` }}
              >
                {description}
              </p>
              <Button
                mode={`${mode === "light" ? "dark" : "light"}`}
                label={buttonText}
                icon="play"
                size="sm"
                testID="heroVideoPlayBtn"
                iconRight
                onClick={handleButtonClick}
              />
            </div>
          </div>
          {heroLogo ? (
            <Image
              className="p-lg pl-xl w-3xl h-auto"
              alt={description}
              sources={heroLogo}
            />
          ) : null}
        </div>
      </div>

      {/* Content for mobile */}
      <div className="flex md:hidden flex-col w-full p-md items-start space-y-sm justify-between bg-gray-800 rounded-b-lg text-white">
        {heroLogo ? (
          <Image
            className="w-auto h-xl pr-lg"
            alt={description}
            sources={heroLogo}
          />
        ) : null}
        <p className="gn-headline-sm font-bold">{title}</p>
        <p className="gn-text-sm mb-md">{description}</p>
        <Button
          mode="light"
          label={buttonText}
          icon="play"
          size="sm"
          iconRight
          onClick={handleButtonClick}
        />
      </div>
    </>
  );
}

HeroVideo.propTypes = {
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  mode: PropTypes.string,
  description: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func,
  source: PropTypes.string,
  heroLogo: ImageSourcesType,
  fallbackImageSource: ImageSourcesType.isRequired,
};

HeroVideo.defaultProps = {
  heroLogo: null,
  handleButtonClick: () => {},
  buttonText: "Play Video",
  mode: "light",
  source: undefined,
};
